import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

/*
 * Firebase App Check nas páginas PÚBLICAS (loja /loja/… e orçamento
 * /orcamento/…): prova para as Cloud Functions que a chamada veio do site do
 * Print Control, e não de um robô usando a API direto (pedidos falsos, teste
 * de cartão, força bruta no login de cliente). Provedor: reCAPTCHA Enterprise
 * — o único do App Check para navegador. É invisível para o cliente.
 *
 * Só no navegador, em HTTPS. Fica de fora (por enquanto):
 *  - desktop (Electron, file://): o App Check não suporta;
 *  - app Android: precisa do Play Integrity nativo (fase 2);
 *  - localhost/emuladores: lá nada é exigido.
 * O painel do vendedor não liga o App Check (não é exigido nele, e cada token
 * conta na cota grátis do reCAPTCHA).
 *
 * A chave do site (REACT_APP_APPCHECK_SITE_KEY) é pública por natureza.
 * Exigir ou só monitorar é decidido no servidor (APP_CHECK_LOJA em
 * functions/.env.matriz3dsite). Ver docs/app-check.md.
 */

const CHAVE_SITE = process.env.REACT_APP_APPCHECK_SITE_KEY || "";
const ativados = new WeakSet();

export function appCheckDisponivel(win = typeof window !== "undefined" ? window : undefined) {
  if (!CHAVE_SITE || !win) return false;
  if (win.electronAPI) return false;
  if (win.Capacitor?.isNativePlatform?.()) return false;
  return win.location?.protocol === "https:";
}

// Liga o App Check num app Firebase (uma vez por app). Nunca quebra a página:
// sem App Check a chamada segue sem token e o servidor decide.
export function ativarAppCheck(app) {
  if (!app || ativados.has(app) || !appCheckDisponivel()) return false;
  try {
    initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(CHAVE_SITE), isTokenAutoRefreshEnabled: true });
    ativados.add(app);
    return true;
  } catch (e) {
    console.warn("App Check não iniciou:", e?.code || e?.message);
    return false;
  }
}

/* A função recusou a chamada na verificação do Firebase (sem token do App
   Check válido — ou sessão inválida, que recebe a mesma resposta). As
   nossas próprias recusas vêm sempre com mensagem em português. */
export const erroDeVerificacao = e => String(e?.code || "").endsWith("unauthenticated") && e?.message === "Unauthenticated";

export const MENSAGEM_VERIFICACAO = "Não foi possível confirmar este acesso. Atualize a página e tente de novo; se continuar, desative o bloqueador de anúncios nesta página.";
